// type safe paths
// https://github.com/garybernhardt/static-path
//
// tip: unless you're adding the route to the router, always call these as a
// function even if they don't take parameters
// e.g.  <Link to={rootPath({})}> and not <Link to={rootPath.pattern}>

import { path } from "static-path"

export const rootPath = path("/")
export const adminLoginPath = path("/admin/login")
export const adminCredentialsLoginPath = path("/admin/login/credentials")
export const adminDashboardPath = path("/admin")
export const adminAdminUsersPath = path("/admin/admin-users")
export const adminNewAdminUserPath = path("/admin/admin-users/new")
export const adminUsersPath = path("/admin/users")
export const adminEditUserPath = path("/admin/users/:id/edit")
export const adminUserEarningsPath = path("/admin/users/:id/earnings")
export const adminUserDetailPath = path("/admin/users/:id")
export const adminRoomsPath = path("/admin/chats")
export const adminCreateDemoRoomPath = path("/admin/chats/create-demo")
export const adminUploadVipBadgePath = path("/admin/upload-vip-badge")
export const adminRoomPath = path("/admin/chats/:id")
export const adminRoomVipsPath = path("/admin/chats/:id/vips")
export const adminSubscriptionProductsPath = path("/admin/chats/:id/subscription-products")
export const adminRoomSubscriptionsPath = path("/admin/chats/:id/subscriptions")
export const adminRoomHostStatsPath = path("/admin/chats/:id/host-stats")
export const adminCacheStatsPath = path("/admin/cache-stats")
export const adminLoadSheddingStatsPath = path("/admin/load-shedding-stats")
export const adminNewMemberStatsPath = path("/admin/new-member-stats")
export const adminPredictionsPath = path("/admin/predictions")
export const adminEarningsPlansPath = path("/admin/earnings-plans")
export const adminEarningsPlanPath = path("/admin/earnings-plans/:id")
export const adminEditEarningsPlanPath = path("/admin/earnings-plans/:id/edit")
export const adminEarningsEventsPath = path("/admin/earnings-plans/:id/events")
export const adminCreateEarningsPlanPath = path("/admin/earnings-plans/create")
export const adminCreatePredictionGroupPath = path("/admin/predictions/create")
export const adminAuraProductsPath = path("/admin/aura/products")
export const adminAuraCashOutPath = path("/admin/aura/cash-outs")
export const adminAuraCashOutHistoryPath = path("/admin/aura/cash-outs/:userId")
export const adminAdSponsorsPath = path("/admin/ads/sponsors")
export const adminAdCampaignsPath = path("/admin/ads/campaigns")
export const adminAdCampaignPath = path("/admin/ads/campaigns/:id")
export const adminUpdatePredictionGroupPath = path("/admin/predictions/:id/edit")
export const adminInputPredictionResultsPath = path("/admin/predictions/:id/results")
export const adminEditRoomPath = path("/admin/chats/:id/edit")
export const adminRoomTopMessagesPath = path("/admin/chats/:id/top-messages")
export const adminRoomEventsPath = path("/admin/chats/:id/events")
export const adminRoomScheduledMessagesPath = path("/admin/chats/:id/scheduled-messages")
export const adminRoomEpisodesPath = path("/admin/chats/:id/episodes")
export const adminRoomEpisodeListPath = path("/admin/chats/:id/episodes/list")
export const adminRoomEpisodeSourcesPath = path("/admin/chats/:id/episodes/sources")
export const adminEpisodePath = path("/admin/episodes/:id")
export const adminEpisodeTranscriptPath = path("/admin/episodes/:id/transcript")
export const adminEpisodeClipsPath = path("/admin/episodes/:id/clips")
export const adminEpisodeSuggestionsPath = path("/admin/episodes/:id/:category")
export const adminCreateRoomEventPath = path("/admin/chats/:id/events/new")
export const adminEditRoomEventPath = path("/admin/chats/:id/events/:eventId/edit")
export const adminMessageModerationPath = path("/admin/moderation/messages/:moderationResult")
export const adminUserModerationPath = path("/admin/moderation/users")
export const adminMessageDetailPath = path("/admin/messages/:id")
export const detailsPath = path("/details")
export const profilePath = path("/profile")
export const downloadPath = path("/download")
export const landingPath = path("/landing")
export const comingSoonPath = path("/coming-soon")
export const privacyPath = path("/privacy")
export const termsPath = path("/terms")
export const supportPath = path("/support")
export const shareRoomPath = path("/:room_handle")
export const shareLiveSessionPath = path("/:room_handle/live/:live_session_id")
export const shareMessagePath = path("/:room_handle/m/:message_id")
export const shareMessageCommentPath = path("/:room_handle/m/:parent_message_id/:message_id")
export const sharePostPath = path("/:room_handle/p/:message_id")
export const sharePostCommentPath = path("/:room_handle/p/:parent_message_id/:message_id")
export const invitePath = path("/invite")

export const shareRoomCardPath = path("/:room_handle/card")
export const shareMessageCardPath = path("/:room_handle/m/:message_id/card")

export const emailAuthPath = path("/auth/email/:email/:token/:clientAuthCode")
export const featureFlagsPath = path("/admin/features")
export const sidekiqPath = path("/sidekiq")
export const pgheroPath = path("/pghero")
export const graphqlPath = path("/graphql/dashboard")
export const graphiqlPath = path("/graphiql")
